import React from "react";
import {FooterStyle, Link, LogoContainer, FooterTop, FooterBottom, LogoSection} from "./Footer.css";
import logo from '/assets/logo_CMS.svg?url';
import {useNavigate} from "react-router-dom";

function Footer() {
    const navigate = useNavigate()
    return (
        <div className={FooterStyle}>
            <div className={FooterTop}>
                <div className={LogoSection}>
                    <div className={LogoContainer}>
                        <img src={logo} alt="Logo" style={{height: "50px"}} />
                    </div>

                </div>

            </div>

            <div className={FooterBottom}>
                <div style={{display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap"}}>
                    <span>GIE CM Services © 2026</span>
                    <span>-</span>
                    <span>Tous droits réservés</span>
                </div>
                <div style={{display: "flex", gap: "20px", alignItems: "center", flexWrap: "wrap"}}>
                    <a className={Link} target={"blank"} href={"https://www.ccmdirect.fr/rgpd"}>Politiques Cookies</a>
                    <a className={Link} target={"blank"} href={"https://www.ccmdirect.fr/infos"}>Mentions légales</a>
                </div>
            </div>
        </div>
    );
}

export default Footer;